import { render, staticRenderFns } from "./ChallengeResult.vue?vue&type=template&id=5baaaf52&scoped=true&"
import script from "./ChallengeResult.vue?vue&type=script&lang=js&"
export * from "./ChallengeResult.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeResult.vue?vue&type=style&index=0&id=5baaaf52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baaaf52",
  null
  
)

export default component.exports